/**
 * Порог возврата — общий для возврата продажи и выплаты с депозита (план 150
 * Ф3, решение владельца 4: «те же права и лимит, что у возврата»).
 *
 * До порога включительно деньги отдаёт любой с правом `refund:under_limit`.
 * Сверх порога: возврат продажи создаётся в ожидании одобрения (одобряет
 * другой сотрудник с `refund:over_limit`), выплату с депозита сразу проводит
 * только обладатель `refund:over_limit` — очереди одобрения у неё нет.
 *
 * Перенос в настройки тенанта — вне плана 150 (гоча §3 плана).
 */
export const REFUND_AUTO_APPROVE_LIMIT_KOPECKS = 500_000; // 5 000 ₽

/**
 * Виды уведомлений очереди возвратов (план 168 §2.5, решение В4). Пишет их
 * `RefundSaleCommand` / `ApproveRefundCommand` / `RejectRefundCommand`;
 * тексты — в каталоге `employee-notification-kinds.ts`.
 *
 * payload (snake_case): `refund_id`, `sale_id`, `client_id`, `client_name`,
 * `client_no`, `amount_kopecks`, `method`, `branch_name`; у отказа ещё
 * `rejection_reason`. В Telegram из них идут только сумма, способ и филиал.
 */
export const REFUND_APPROVAL_REQUESTED = 'refund.approval_requested';
export const REFUND_APPROVED = 'refund.approved';
export const REFUND_REJECTED = 'refund.rejected';
